var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('loading-icon',{attrs:{"value":_vm.iframeLoader}}),_c('iframe',{attrs:{"src":_vm.iframeUrl,"frameborder":"0"},on:{"load":_vm.load}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }